// Calendar days between a timestamp and "today" in the viewer's local
// timezone. Using local midnights (via Date.UTC of getFullYear/Month/Date)
// keeps a 7-day outreach cadence from flipping overnight just because the
// attempt was logged late in the evening.
export const calendarDaysSince = (d, now = new Date()) => {
  if (!d) return null;
  const date = d instanceof Date ? d : new Date(d);
  if (isNaN(date.getTime())) return null;
  const start = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
  const end = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.floor((end - start) / 86400000);
};
